<div class="notifications-header">
  <div class="header-top">
    <div class="title">{{ 'title.notifications.title' | translate }}</div>
    <i class="bi bi-x-lg" (click)="close.emit()"></i>
  </div>
  <hr />
  
  <div class="header-controls">
    <div class="left-controls">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          [(ngModel)]="viewUnreadOnly"
          (change)="toggleViewUnreadOnly()"
          type="checkbox"
          role="switch"
          id="checkbox-unread"
        />
        <label class="form-field-label__checkbox" for="checkbox-unread">
          {{ 'label.view_unread_only' | translate }}
        </label>
      </div>
      @if(!impersonateService.impersonatedUser) {
        <button class="mark-read-btn" (click)="markAllAsRead()">{{ 'buttons.mark_all_as_read' | translate }}</button>
      }
    </div>

    <div class="right-controls">
      <app-notifications-filter [activeFilters]="activeFilters" (filtersChanged)="onFiltersChanged($event)"></app-notifications-filter>
    </div>
  </div>
  <hr />
</div>